import React, {Component} from 'react'
import PropsTypes from 'prop-types'
import {ModalBody, ModalHeader} from "reactstrap"
import {_updateProxyData} from "../../../../../services/apis/ProxiesServices";

class UpdateProxyDataForm extends Component {
    state = {
        modalData: this.props.modalData,
        isUpdating: false
    }

    _handleSubmit = (e) => {
        e.preventDefault()

        const {modalData} = this.state
        this.setState({
            isUpdating: true
        })

        _updateProxyData(modalData._id, modalData)
            .then(result => {
                if (result.success) {
                    this.props.onCloseModal()
                    this.props.onUpdateListProxy(modalData)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }

    _handleChangeTextForm = field => e => {
        const {value} = e.target
        this.setState(({modalData}) => ({
            modalData: {
                ...modalData,
                [field]: value
            }
        }))
    }

    render() {
        const {country, note} = this.state.modalData
        const {isUpdating} = this.state

        return (
            <div>
                <ModalHeader toggle={this.toggle}>Edit</ModalHeader>
                <ModalBody>
                    <form onSubmit={this._handleSubmit}>
                        <div className="form-group">
                            <div className="row">
                                <div className="col-3">
                                    <label>Country</label>
                                </div>
                                <div className="col-9">
                                    <input className="form-control" value={country} placeholder="Country"
                                           onChange={this._handleChangeTextForm('country')}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="form-group">
                            <div className="row">
                                <div className="col-3">
                                    <label>Note</label>
                                </div>
                                <div className="col-9">
                                    <input className="form-control" value={note || ''} placeholder="Note"
                                           onChange={this._handleChangeTextForm('note')}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="form-group">
                            <button className="btn btn-success" type='submit' disabled={isUpdating}>Update</button>
                        </div>
                    </form>
                </ModalBody>
            </div>
        )
    }
}

UpdateProxyDataForm.propsType = {
    onToggleModal: PropsTypes.func.isRequired,
    modalData: PropsTypes.func.isRequired,
    onUpdateListProxy: PropsTypes.func.isRequired,
    onChangeModalData: PropsTypes.func.isRequired,
    onCloseModal: PropsTypes.func.isRequired
}

export default UpdateProxyDataForm


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/proxies/component/UpdateProxyDataForm.js